import postal from 'postal';
import { useContext, useEffect } from 'react';

import { useMst } from '@/mobx-models/Root';

import { kind as selectBorer } from './actions/SelectBorer';
import { dataManagerContext } from './dataManagerContext';

export function useBorerSelection() {
  // The legacy code depends on both `equipment.selectedBorerId` and the `borer.selected` message.
  // This is probably excessive and unnecessary.

  const { dispatch } = useContext(dataManagerContext);
  const { equipment } = useMst();

  useEffect(() => {
    dispatch({
      borerSelected: !!equipment.selectedBorerId,
      kind: selectBorer,
    });
  }, [equipment.selectedBorerId, dispatch]);

  useEffect(() => {
    const postalSub = postal.subscribe({
      channel: 'borer',
      topic: 'borer.selected',
      callback: () =>
        dispatch({
          borerSelected: true,
          kind: selectBorer,
        }),
    });

    return () => postalSub.unsubscribe();
  }, [dispatch]);
}
